import { Avatar } from '@material-ui/core';
import { getInfosDashboard } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const AvatarStudent = ({ applicant, height = 60, width = 60, className }) => {
  const { css } = useStyles();
  const { data: infos = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', applicant?.id],
    variables: { id: applicant?.id },
  });

  return infos?.profile?.profileImageUrl ? (
    <Avatar
      className={css({
        height,
        width,
        ...className
      })}
      src={infos?.profile?.profileImageUrl}
    />
  ) : (
    <Avatar
      className={css({
        height,
        width,
        ...className
      })}
    >
      {applicant?.lastname?.substr(0, 1)} {applicant?.firstname?.substr(0, 1)}
    </Avatar>
  );
};

AvatarStudent.propTypes = {
  applicant: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string
};

export default AvatarStudent;
